import React from 'react';

const SiteFooter: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/ElevenUpLogo.png" alt="ElevenUp" className="footer-logo" />
            <span>ElevenUp</span>
          </div>
          <div className="footer-links">
            <a href="/about">About</a>
            <a href="/blog">Blog</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/contact">Contact</a>
          </div>
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} 11 Up Company Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
